import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
const db = firebase.firestore()

const state = {
  tasks: []
}

const actions = {
  GET_TASKS ({ commit }) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('tasks')
      let unsub = ref.onSnapshot(snapshot => {
        let tasks = []
        snapshot.forEach((doc) => {
          tasks.push(doc.data())
        })
        commit('SET_TASKS', tasks)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  },
  CREATE_TASK ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload.form
      db.collection('tasks')
        .add(data)
        .then(snapshot => {
          data.id = snapshot.id
          db.collection('tasks')
            .doc(snapshot.id)
            .update(data)
            .then(snapshot => {
              resolve(snapshot)
            })
            .catch(reject)
        })
        .catch(reject)
    })
  },
  UPDATE_TASK ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload
      db.collection('tasks')
        .doc(data.id)
        .update({
          title: data.title,
          createdAt: data.createdAt,
          isComplete: data.isComplete,
          description: data.description,
          assignedTo: data.assignedTo,
          createdBy: data.createdBy
        })
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  DELETE_TASK ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('tasks')
        .doc(payload.id)
        .delete()
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  }
}

const getters = {
}

const mutations = {
  SET_TASKS (state, payload) {
    state.tasks = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
